import type { GeneratedQuizDto } from './generated-quiz.dto.js';
import type { CreateQuizBody } from './quiz.dto.js';

interface QuestionDraft {
  text: string;
  options: { label: string; isCorrect: boolean }[];
}

// Ids are minted here and never leave: the generator makes none, and the
// entity only needs them unique within one quiz.
export const withIds = (questions: QuestionDraft[]) =>
  questions.map((question, index) => ({
    id: `q${index + 1}`,
    text: question.text,
    options: question.options.map((option, position) => ({
      id: `o${position + 1}`,
      label: option.label,
      isCorrect: option.isCorrect,
    })),
  }));

/** The quiz carries what it was written from, and it is stored with it so a later Swap reads the same. */
export function toCreateBody(quiz: GeneratedQuizDto): CreateQuizBody {
  return {
    title: quiz.title,
    kit: quiz.kit,
    brief: quiz.brief,
    audience: quiz.audience,
    taught: quiz.taught,
    voice: quiz.voice,
    generationId: quiz.generationId,
    questions: withIds(quiz.questions),
  };
}
